export enum NotificationGroupsQueryKey {
  Me = '/notification-groups/me',
}
